import React from "react";

export default function PaymentLockedWarning() {
  return (
    <div>
      <h3>Dang! Looks like something went wrong.</h3>
      <p>Not to worry, we will sort this out! <a href="mailto:support@cleanfooddirtygirl.com">Contact us here</a> and we will get back to you shortly.</p>
    </div>
  )
}